import React from 'react';
import Navbar from '../components/Navbar';
import '../styles/careersPage.css';
import OwnerMsgTeam from '../components/OwnerMsgTeam';
import CTASection from '../components/CTASection';

const Careers = () => {

  // Smooth scroll function
  const scrollToPositions = (e) => {
    e.preventDefault();
    const element = document.getElementById('positions');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="careers-page">
      <Navbar />

      {/* Hero Section */}
      <section className="careers-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Grow Your Career With All Seasons</h1>
          <p>Join Idaho's Premier Landscaping Team</p>
          <a href="#positions" onClick={scrollToPositions} className="btn-cta">
            View Open Positions
          </a>
        </div>
      </section>
     <OwnerMsgTeam />
      {/* Hiring Message Section */}

      {/* BambooHR Job Embed */}
      <section id="positions" className="positions-section">
        <div className="section-inner">
          <h2 className="section-title">Open Positions</h2>
          <div style={{ 
            minHeight: '400px', 
            marginTop: '2rem',
            background: '#fff',
            borderRadius: '12px',
            padding: '2rem',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
            border: '1px solid rgba(47, 93, 80, 0.1)'
          }}>
            <iframe 
              src="https://allseasons.bamboohr.com/careers" 
              width="100%" 
              height="600"
              style={{ 
                border: 'none',
                borderRadius: '8px',
                display: 'block',
                background: '#f5f5f5'
              }}
              title="All Seasons Job Listings"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="section benefits-section">
        <div className="section-inner">
          <div className="text-center mb-4">
            <h2 className="section-title">Why Work at All Seasons?</h2>
          </div>
          
          <div className="value-props-grid">
            <div className="value-prop-card featured">
              <div className="value-number">35+</div>
              <h3>Years of Stability</h3>
              <p className="value-description">
                Join a company with over three decades of growth and success in the Wood River Valley.
              </p>
            </div>
            
            <div className="value-prop-card">
              <div className="value-number">$$$</div>
              <h3>Competitive Wages</h3>
              <p className="value-description">
                We offer industry-leading pay with overtime opportunities and performance bonuses.
              </p>
            </div>
            
            <div className="value-prop-card">
              <div className="value-number">60+</div>
              <h3>Growing Team</h3>
              <p className="value-description">
                Join Idaho's largest landscaping team with opportunities for advancement and leadership.
              </p>
            </div>
            
            <div className="value-prop-card">
              <div className="value-number">365</div>
              <h3>Year-Round Opportunity</h3>
              <p className="value-description">
                Seasonal and full-time positions available with flexible scheduling options.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection 
        title="Ready to Join Our Team?"
        subtitle="Take the first step toward a rewarding career in landscaping. We can't wait to meet you!"
        galleryLink="/gallery"
        showEmergency={false}
      />
    </div>
  );
};

export default Careers;